export default __webpack_public_path__ + "static/media/nominateRequest.0bc123e1.svg";